import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-auth-kit";
import ReactDOM from "react-dom/client";

import App from "./App";

if (process.env.NODE_ENV === "production") {
  console.error = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider
      authType={"cookie"}
      authName={"_auth"}
      cookieDomain={window.location.hostname}
      cookieSecure={window.location.protocol === "https:"}
    >
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);
